export default function RailRoundtripController(
    $scope,
    $controller,
    railsFactory,
    $window,
    $stateParams
) {
    'ngInject';

    $controller('RailRoundtripBaseController', {
        $scope,
        $window,
        $stateParams,
        railsFactory,
    });
}



// WEBPACK FOOTER //
// ./src/app/modules/ukrail/controllers/ukrailRoundtripCtrl.js